import React from 'react';

import IconButton from '@material-ui/core/IconButton';

import { SdmTypography } from '.';
import { theme } from '../theme';
import { styled } from '@material-ui/core/styles';

const variants = {
  black: {
    border: '2px solid ' + theme.colors.greyScale.black,
    color: theme.colors.greyScale.grey,
    '&:hover': {
      background: 'transparent !important',
    },
    '&:disabled': {
      color: theme.colors.greyScale.grey,
      background: 'transparent !important',
      opacity: 0.23,
    },
  },
  red: {
    border: '2px solid ' + theme.colors.secondary.red,
    color: theme.colors.greyScale.white,
    '&:hover': {
      background: 'transparent !important',
    },
    '&:disabled': {
      color: theme.colors.greyScale.grey,
      background: 'transparent !important',
      opacity: 0.23,
    },
  },
  blackTissueFill: {
    color: theme.colors.greyScale.white,
    background: 'rgba(0,0,0,0.3)',
    '&:hover': {
      background: 'rgba(0,0,0,0.6) !important',
    },
    '&:disabled': {
      color: theme.colors.greyScale.white,
      background: 'rgba(0,0,0,0.3)',
      opacity: 0.23,
    },
  },
  redFill: {
    background: theme.colors.primary.red,
    color: theme.colors.greyScale.white,
    '&:hover': {
      color: theme.colors.greyScale.white,
      background: theme.colors.dark.red,
    },
    '&:disabled': {
      background: `${theme.colors.primary.red} !important`,
      color: theme.colors.greyScale.white,
      opacity: 0.23,
    },
  },
  none: {
    border: '2px solid transparent',
    color: theme.colors.greyScale.grey,
    '&:hover': {
      background: 'transparent !important',
    },
    '&:disabled': {
      color: theme.colors.greyScale.grey,
      background: 'transparent !important',
      opacity: 0.23,
    },
  },
};

const CustomIconButton = styled(IconButton)(
  ({ variant = 'red', small = false }) => ({
    borderRadius: 0,
    height: small ? 30 : 40,
    margin: 4,
    padding: 12,
    cursor: 'pointer',
    ...variants[variant],
  })
);

const CustomButton = (
  { text, textColor, isUpperCase = false, children, ...rest },
  ref
) => (
  <CustomIconButton ref={ref} {...rest} disableRipple disableFocusRipple>
    {children}
    {text && (
      <SdmTypography
        variant="text"
        style={{
          color: textColor ? textColor : theme.colors.greyScale.black,
          textTransform: isUpperCase ? 'uppercase' : 'none',
        }}
      >
        {text}
      </SdmTypography>
    )}
  </CustomIconButton>
);

CustomButton.displayName = 'SdmIconAndTextButton';

export const SdmIconAndTextButton = React.forwardRef(CustomButton);
